import { createBrowserRouter } from 'react-router-dom'
import RootLayout from '../../pages/root/root'
import ErrorPage from '../../pages/root/error'
import PTSForm from '../../pages/ptsform'

export const router = createBrowserRouter([
    {
        path: '/',
        element: <RootLayout />,
        errorElement: <ErrorPage />,

        children: [
            { index: true, element: <PTSForm defaultLanguage="sv" /> },
            {
                path: 'english',
                element: <PTSForm defaultLanguage="en" />,
            },
        ],
    },
])
